"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../table/table-cells");
function useColumns(options) {
    const intl = react_intl_1.useIntl();
    const columns = react_1.useMemo(() => {
        var _a;
        return [
            ...((_a = options.columns) !== null && _a !== void 0 ? _a : []),
            {
                datakey: 'createdBy',
                displaykey: 'createdBy.name',
                sortkey: 'createdBy.name',
                filterkey: 'createdBy.name',
                name: intl.formatMessage({
                    id: 'EAS_EVIDENCE_COLUMN_CREATED_BY',
                    defaultMessage: 'Autor',
                }),
                width: 150,
                CellComponent: table_cells_1.TableCells.TextCell,
                sortable: true,
                filterable: true,
            },
            {
                datakey: 'updatedBy',
                displaykey: 'updatedBy.name',
                sortkey: 'updatedBy.name',
                filterkey: 'updatedBy.name',
                name: intl.formatMessage({
                    id: 'EAS_EVIDENCE_COLUMN_UPDATED_BY',
                    defaultMessage: 'Autor úpravy',
                }),
                width: 150,
                CellComponent: table_cells_1.TableCells.TextCell,
                sortable: true,
                filterable: true,
            },
        ];
    }, [options.columns, intl]);
    return columns;
}
exports.useColumns = useColumns;
//# sourceMappingURL=authored-columns.js.map